import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class HistoryBack extends WebComponent {
  constructor(props) {
    super(props);
    this.handlerClick = this.handlerClick.bind(this);
  }

  didMount() {
    this.on("click", this.handlerClick);
  }

  handlerClick(e) {
    if(document.referrer.search(location.origin) == 0 && history.length > 1) {
      e.preventDefault();
      history.back();
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/HistoryBack.js